import React from 'react';
import Script from 'next/script';

import { IOutgrowFields } from '@/types/contentful';

export default function InPage({ code, iframeId }: Partial<IOutgrowFields>) {
  return code ? (
    <div className="block-container mb-3 tablet:mb-[160px]">
      <div className="layout px-3 tablet:px-12 -mx-2 tablet:-mx-3 desktop:-mx-4">
        <div
          className="max-h-[45rem] w-full px-2 tablet:px-3 desktop:px-4"
          dangerouslySetInnerHTML={{ __html: code || '' }}
          data-testid="outgrow-inpage"
        />
        <Script
          id="outgrow-inpage"
          strategy="afterInteractive"
        >{`var og_temp=document.createElement('script');og_temp.async=true;og_temp.defer=true;og_temp.src='//dyv6f9ner1ir9.cloudfront.net/assets/js/nloader.js',og_temp.onload=function(){initIframe('${iframeId}')},document.querySelector('head').appendChild(og_temp)`}</Script>
      </div>
    </div>
  ) : null;
}
